import { ObjectPosition } from "../../types/objectPosition.ts";

type ComponentType = "ReserveCar" | "ReserveButton" | "Contact" | "Phonenumber" | "CallMeBack";

type VisibleActionsHelperParams = {
  position: ObjectPosition;
  hideWriteToSeller?: boolean;
  phoneNumberCallbackUrl?: string;
  orgPhoneNumber?: string;
  reservationEnabled: boolean;
  isItemReserved: boolean;
  callMeBackEnabled?: boolean;
};

export const visibleActionsHelper = ({
  position = ObjectPosition.NonStickyCTA,
  hideWriteToSeller = false,
  phoneNumberCallbackUrl,
  orgPhoneNumber,
  reservationEnabled,
  isItemReserved,
  callMeBackEnabled = false,
}: VisibleActionsHelperParams): ComponentType[] => {
  const components: ComponentType[] = [];

  if (reservationEnabled && [ObjectPosition.StickyCTA, ObjectPosition.NonStickyCTA].includes(position)) {
    if (position === ObjectPosition.NonStickyCTA) {
      components.push("ReserveCar");
    } else if (!isItemReserved) {
      components.push("ReserveButton");
    }
  }

  if (!hideWriteToSeller) {
    components.push("Contact");
  }
  if (phoneNumberCallbackUrl || orgPhoneNumber) {
    components.push("Phonenumber");
  }

  if (callMeBackEnabled && position === ObjectPosition.NonStickyCTA) {
    components.push("CallMeBack");
  }

  if (position === ObjectPosition.InfoCard) {
    components.reverse();
  }

  if (position === ObjectPosition.StickyCTA) {
    return components.slice(0, 2);
  }
  return components;
};
